import { AbilityTypeId, ModelType } from '../api';

export const DefaultQuestions = {
    [AbilityTypeId.RESOURCE_COURSE]: [
        {
            key: '000',
            description: `“请帮我推荐关于“人工智能”的培训课程“`
        },
        {
            key: '001',
            description: `“请帮我推荐关于”师德师风“的培训课程”`
        },
        {
            key: '002',
            description: `“请帮我推荐关于“教育现代化”的培训课程。”`
        }
    ],
    [AbilityTypeId.RESOURCE_CASE]: [
        {
            key: '100',
            description: `“关于”名校长培养工程“有哪些经典案例？“`
        },
        {
            key: '101',
            description: `“请帮我推荐关于”职业本科“的相关案例”`
        },
        {
            key: '102',
            description: `“请关于推荐关于”教学能力“的相关案例“`
        }
    ],
    [AbilityTypeId.RESOURCE_DIGITAL_RESOURCE]: [
        {
            key: '200',
            description: `“请帮我推荐关于”教师管理“的相关资源？“`
        },
        {
            key: '201',
            description: `“请帮我推荐关于”人工智能“的相关资源？”`
        },
        {
            key: '202',
            description: `“请帮我推荐关于”政治素养“的相关资源？”`
        }
    ],
    [AbilityTypeId.RESOURCE_EXPERT]: [
        {
            key: '300',
            description: `“请帮我推荐关于”心理健康“领域的专家”`
        },
        {
            key: '301',
            description: `“艺术教育比较权威的专家都有哪些呢？`
        },
        {
            key: '302',
            description: `“请帮我推荐关于”教育管理“方面的专家“`
        }
    ],
    [AbilityTypeId.PARTNER_JOB]: [],
    [AbilityTypeId.PARTNER_COURSE]: [],
    [AbilityTypeId.PARTNER_PERSONAL_TRAINING]: [],
    [AbilityTypeId.PARTNER_PROJECT]: [],
    [ModelType.ASSISTANT]: [
        {
            key: '400',
            description: `“怎样使用学习卡开始学习？”`
        },
        {
            key: '401',
            description: `“忘记登录密码怎么办？”`
        },
        {
            key: '402',
            description: `“学员怎样查看项目/班级基本信息？“`
        }
    ],
    [ModelType.PROJECT]: [
        {
            key: '500',
            description: `“基础教育教师培训都有哪些重点项目？”`
        },
        {
            key: '501',
            description: `“高校教师想要突破信息化现状，应该参与哪些项目？”`
        },
        {
            key: '502',
            description: `“2025年有哪些重点的示范项目？“`
        }
    ],
    [ModelType.ASSISTANT_COMMON]: [
        {
            key: '600',
            description: `“3D概念动画“`
        }
    ]
};
export const Assistant_New_Questions = {
    [ModelType.POLICY_PAPERS]: [
        {
            key: '100',
            description: `“辅导员的岗位能力标准有哪些具体要求？”`
        },
        {
            key: '101',
            description: `“最新的辅导员政策文件有哪些重点内容？”`
        },
        {
            key: '102',
            description: `“如何解读与辅导员相关的法规条款？”`
        }
    ],
    [ModelType.IDEOLOGICAL_VALUES]: [
        {
            key: '200',
            description: `“思想政治教育中如何引导学生树立正确的价值观？”`
        },
        {
            key: '201',
            description: `“有哪些经典的思想政治教育案例可以参考？”`
        },
        {
            key: '202',
            description: `“如何提升思想政治教育的吸引力和实效性？”`
        }
    ],
    [ModelType.CAUCUS_CLASSES]: [
        {
            key: '300',
            description: `“如何开展党团组织建设活动？”`
        },
        {
            key: '301',
            description: `“班级管理有哪些有效的策略和方法？”`
        },
        {
            key: '302',
            description: `“如何培养优秀的班级干部团队？”`
        }
    ],
    [ModelType.STUDENT_ACADEMICS]: [
        {
            key: '400',
            description: `“如何为学生制定合理的学业规划？”`
        },
        {
            key: '401',
            description: `“如何帮助学生应对学业困难和挫折？”`
        },
        {
            key: '402',
            description: `“如何引导学生培养自主学习能力？”`
        }
    ],
    [ModelType.EVERYDAY_MATTERS]: [
        {
            key: '500',
            description: `“学生宿舍管理有哪些注意事项？”`
        },
        {
            key: '501',
            description: `“奖助学金评定的标准和流程是什么？”`
        },
        {
            key: '502',
            description: `“学籍管理中常见的问题有哪些？”`
        }
    ],
    [ModelType.MENTAL_HEALTH]: [
        {
            key: '600',
            description: `“心理咨询中有哪些常用的技术和方法？”`
        },
        {
            key: '601',
            description: `“如何识别学生常见的心理问题？”`
        },
        {
            key: '602',
            description: `“危机干预的流程和要点是什么？”`
        }
    ],
    [ModelType.INTERNET_IDEOLOGY_AND_POLITICS]: [
        {
            key: '700',
            description: `“如何应对网络舆情事件？”`
        },
        {
            key: '701',
            description: `“如何引导学生正确使用网络？”`
        },
        {
            key: '702',
            description: `“网络思想政治教育中如何增强学生的参与感？”`
        }
    ],
    [ModelType.CRISIS_EVENTS]: [
        {
            key: '800',
            description: `“危机事件的预警机制如何建立？”`
        },
        {
            key: '801',
            description: `“突发事件的应急处理流程是什么？”`
        },
        {
            key: '802',
            description: `“如何在危机事件中安抚学生情绪？”`
        }
    ],
    [ModelType.EMPLOYMENT_AND_ENTREPRENEURSHIP]: [
        {
            key: '900',
            description: `“如何帮助学生进行职业规划？”`
        },
        {
            key: '901',
            description: `“简历撰写有哪些要点和技巧？？”`
        },
        {
            key: '902',
            description: `“面试中常见的问题及应对策略是什么”`
        }
    ],
    [ModelType.SCIENTIFIC_RESEARCH_CAPABILITIES]: [
        {
            key: '1000',
            description: `“如何开展辅导员工作的实践研究？”`
        },
        {
            key: '1001',
            description: `“有哪些优秀的辅导员工作研究案例可以参考？”`
        },
        {
            key: '1002',
            description: `“研究方法在辅导员工作中如何应用？”`
        }
    ],
    [ModelType.ASSISTANT_PARTNER]: [
        {
            key: '1100',
            description: `“我需要完成哪些考核呢？”`
        },
        {
            key: '1101',
            description: `“培训什么时候开始，什么时候结束？”`
        },
        {
            key: '1102',
            description: `“本次示范班有哪些课程内容呢？”`
        },
        {
            key: '1103',
            description: `“我要去哪个平台学习，需要完成哪些学习环节呢？”`
        }
    ],
    [ModelType.POLICY_NAV]: [
        {
            key: '1200',
            description: `“教学强国规划纲要对职业教育改革发展是怎么要求的？”`
        },
        {
            key: '1201',
            description: `“大中小思政一体化政策要求怎么做？”`
        },
        {
            key: '1202',
            description: `“中职教育的发展趋势和方向侧重点是什么呢？”`
        }
    ],
    [ModelType.CAUCUS_JOB]: [
        {
            key: '1300',
            description: `“党建与业务双融合，职业院校有哪些好的做法？”`
        },
        {
            key: '1301',
            description: `“教师党员和学生党员怎么发展？”`
        }
    ],
    [ModelType.MORAL_EDUCATION_JOB]: [
        {
            key: '1400',
            description: `“学员对集体活动没有热情，请给我一些德育活动设计的创新思路？”`
        },
        {
            key: '1401',
            description: `“我想将劳动教育融入教学中，有什么好的方法？”`
        },
        {
            key: '1402',
            description: `“学生反馈遭遇欺凌，我应该怎么处理？”`
        }
    ],
    [ModelType.CLASSES_MANAGE]: [
        {
            key: '1500',
            description: `“我想打造积极向上、团结友爱的班级文化，具体怎么做好呢？”`
        },
        {
            key: '1501',
            description: `“学生违纪，我该怎么正向引导呢？”`
        },
        {
            key: '1502',
            description: `“给我推荐几个新颖的主题班会题目？”`
        }
    ],
    [ModelType.MENTAL_HEALTH_NEW]: [
        {
            key: '1600',
            description: `“有些学生不知怎么和异性相处，我该怎么引导学生建立健康的男女同学关系呢？”`
        },
        {
            key: '1601',
            description: `“学生厌学，有辍学的打算，我该怎么劝导呢？”`
        },
        {
            key: '1602',
            description: `“我想了解一下班级学生的心理健康状况，请给我推荐几个测评工具”`
        }
    ],
    [ModelType.PROFESSIONAL_COMPETENCE]: [
        {
            key: '1700',
            description: `“请给我提供一个工匠精神主题活动方案模板”`
        },
        {
            key: '1701',
            description: `“请给我一个教案设计的框架”`
        },
        {
            key: '1702',
            description: `“我想了解学生管理的相关知识和案例，请给我推荐一些材料”`
        }
    ],
    [ModelType.LABOR_EDUCATION]: [
        {
            key: '1800',
            description: `“如何将劳动教育与专业课程深度融合，让学生在职业技能学习中自然提升劳动素养？”`
        },
        {
            key: '1801',
            description: `“面对学生劳动实践积极性不高、参与度低的情况，有哪些行之有效的激励方法和创新教学模式？”`
        },
        {
            key: '1802',
            description: `“在校企合作开展劳动实践时，如何保障学生在企业劳动中的权益与安全呢？”`
        }
    ],
    [ModelType.CUSTOMER_SERVICE_ASSISTANT]: [
        {
            key: '1900',
            description: `“我需要完成哪些考核呢？”`
        },
        {
            key: '1901',
            description: `“培训什么时候开始，什么时候结束？”`
        },
        {
            key: '1902',
            description: `“本次示范班有哪些课程内容呢？”`
        },
        {
            key: '1903',
            description: `“我要去哪个平台学习，需要完成哪些学习环节呢？”`
        }
    ],
    [ModelType.COMMUNIST_PARTY_SECRETARY]: [
        {
            key: '2000',
            description: `“本次示范班培训时间具体是如何安排的呢？”`
        },
        {
            key: '2001',
            description: `“培训在哪个平台学习？”`
        },
        {
            key: '2002',
            description: `“培训是如何考核的？”`
        },
        {
            key: '2003',
            description: `“本次示范班培训内容主要是什么？”`
        }
    ]
};
